function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.333459 17.6666C0.533459 17.8666 0.786792 17.9599 1.04012 17.9599C1.29346 17.9599 1.56012 17.8666 1.74679 17.6666L9.00007 10.4132L16.2534 17.6665C16.4534 17.8665 16.7067 17.9599 16.96 17.9599C17.2134 17.9599 17.4667 17.8665 17.6667 17.6665C18.0534 17.2799 18.0534 16.6399 17.6667 16.2532L10.4134 8.99988L17.6667 1.74655C18.0533 1.35988 18.0533 0.71988 17.6667 0.333213C17.28 -0.0534537 16.64 -0.0534537 16.2533 0.333213L9.00007 7.58655L1.74679 0.333252C1.36012 -0.0534147 0.720124 -0.0534147 0.333457 0.333252C-0.0532096 0.719919 -0.0532096 1.35992 0.333457 1.74658L7.58674 8.99989L0.333459 16.2533C-0.053208 16.6399 -0.053208 17.2799 0.333459 17.6666Z",
  fill: "#100B00"
});

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.68be3819.svg";
export { ForwardRef as ReactComponent };